import { _ as __decorate, a as __metadata } from '../tslib.es6-Cv888lzs.js';
import { BaseComponent } from '@italia/globals';
import { css, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';

var styles = css`:host {
  display: block;
  font-family: inherit;
  font-size: inherit;
}

.callout-more {
  display: block;
}`;

let ItCalloutMore = class ItCalloutMore extends BaseComponent {
    constructor() {
        super(...arguments);
        this.variant = 'primary';
        this.size = null;
        this.outline = false;
        this.as = 'button';
        this.defaultOpen = false;
        this.bigText = false;
    }
    render() {
        return html `
      <div class="callout-more">
        <it-callout-more-collapse
          variant="${this.variant}"
          ?default-open=${this.defaultOpen}
          ?big-text=${this.bigText}
          size=${ifDefined(this.size ?? undefined)}
          as=${ifDefined(this.as ?? undefined)}
          ?outline=${this.outline}
          exportparts="button, focusable, trigger, extra, content"
        >
          <span slot="label"><slot name="label"></slot></span>
          <div slot="content"><slot name="content"></slot></div>
          <slot name="extra" slot="extra"></slot>
        </it-callout-more-collapse>
      </div>
    `;
    }
};
ItCalloutMore.styles = styles;
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", String)
], ItCalloutMore.prototype, "variant", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", Object)
], ItCalloutMore.prototype, "size", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItCalloutMore.prototype, "outline", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", Object)
], ItCalloutMore.prototype, "as", void 0);
__decorate([
    property({ type: Boolean, attribute: 'default-open', reflect: true }),
    __metadata("design:type", Object)
], ItCalloutMore.prototype, "defaultOpen", void 0);
__decorate([
    property({ type: Boolean, attribute: 'big-text', reflect: true }),
    __metadata("design:type", Object)
], ItCalloutMore.prototype, "bigText", void 0);
ItCalloutMore = __decorate([
    customElement('it-callout-more')
], ItCalloutMore);

export { ItCalloutMore };
//# sourceMappingURL=it-callout-more.js.map
